import React, { useState } from 'react'
import { FaPhone } from 'react-icons/fa6'

import { ChatFieldsFragment, namedOperations } from '~graphql/generated/graphql'
import ChatInfoAccordionItem from '../info-accordion-item'
import SharedStack from '~components/shared/wrappers/shared-stack'
import ClientPhoneItem from '~components/shared/client/client-phone-item'
import SwitchButton from '~components/shared/switch-button'

export default function ChatClientDetailsPhones({
    chat,
}: {
    chat: ChatFieldsFragment
}) {
    const clientPhones = chat.client.client_phones ?? []
    const primaryPhone =
        clientPhones.find(phone => phone.is_chckup_primary) || null

    const [showInactive, setShowInactive] = useState(false)

    const phonesToShow = showInactive
        ? clientPhones
        : clientPhones.filter(phone => phone.is_active)

    return (
        <ChatInfoAccordionItem icon={FaPhone} title="Phone Numbers" defaultOpen>
            <SharedStack spacing={0} px={4} pt={2} pb={3}>
                {phonesToShow.map(phone => (
                    <ClientPhoneItem
                        key={phone.id}
                        phone={phone}
                        isPrimary={
                            primaryPhone
                                ? primaryPhone?.id === phone.id
                                : phone.is_primary
                        }
                        clinicId={chat?.clinic?.id || ''}
                        clientId={chat?.client.id || ''}
                        country={chat?.clinic?.address?.country ?? undefined}
                        refetchQueries={[namedOperations.Query.getChat]}
                    />
                ))}
                <SwitchButton
                    size="xs"
                    isChecked={showInactive}
                    onClick={() => setShowInactive(prev => !prev)}
                >
                    Show inactive phones
                </SwitchButton>
            </SharedStack>
        </ChatInfoAccordionItem>
    )
}
